 class WholesaleForm extends HTMLElement {
        constructor() {
          super();   
          this.form = this.querySelector('form');
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }
        onSubmitHandler(evt) {
          evt.preventDefault();
          const submitButton = this.querySelector('[type="submit"]');
          submitButton.setAttribute('disabled', true);
          //console.log(this.cart.getSectionsToRender().map((section) => section.id))
          const body = JSON.stringify({
            ...JSON.parse(serializeForm(this.form))
          });
          fetch("https://submit-form.com/hSALUaPs", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body,
          })
            .then(function (response) {
              //console.log(response);
              document.querySelector('.component--wholesale--form').style.display = 'none';
              document.querySelector('.component--wholesale--form__success-message').style.display = 'block';
            })
            .catch(function (error) {
              console.error(error);
            }).finally(() => {
                submitButton.removeAttribute('disabled');
              });
        }
    }
    customElements.define('wholesale-form', WholesaleForm);